var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods_drawer_padding", style: _vm.Styles }, [
    _c(
      "div",
      {
        staticClass: "goods_drawer_inner",
        style: { backgroundColor: _vm.value.config.bg_color || "#fff" },
      },
      [
        _vm.value.config.header_image
          ? _c("el-image", {
              staticStyle: { width: "100%", display: "block" },
              attrs: { src: _vm.value.config.header_image },
            })
          : _vm._e(),
        _vm.bannerList.length > 0
          ? _c(
              "div",
              { staticClass: "banner" },
              [
                _c(
                  "el-carousel",
                  {
                    class: _vm.bannerList.length < 2 && "hideDot",
                    attrs: {
                      trigger: "click",
                      "initial-index": 1,
                      arrow: _vm.bannerList.length < 2 ? "never" : "hover",
                    },
                  },
                  _vm._l(_vm.bannerList, function (item, index) {
                    return _c(
                      "el-carousel-item",
                      { key: index },
                      [
                        _c(
                          "el-image",
                          {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              display: "block",
                            },
                            attrs: { src: item },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "image-slot",
                                attrs: { slot: "error" },
                                slot: "error",
                              },
                              [_c("i", { staticClass: "el-icon-picture" })]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            class: [
              "content",
              _vm.value.config.cols && _vm.value.config.cols < 4 && "hide",
            ],
          },
          _vm._l(_vm.goodsList, function (row, rowIndex) {
            return _c(
              "div",
              { key: rowIndex, staticClass: "rows" },
              [
                _vm._l(row, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "product" },
                    [
                      item.movie_name
                        ? [
                            _c("el-image", {
                              staticClass: "img movie_img",
                              attrs: { src: item.thumb + "" },
                            }),
                            _c("div", { staticClass: "productName" }, [
                              _vm._v(" " + _vm._s(item.movie_name) + " "),
                            ]),
                            _c("div", { staticClass: "price movie" }, [
                              _vm._v(" " + _vm._s(item.publish_time) + " "),
                            ]),
                          ]
                        : [
                            _c("el-image", {
                              staticClass: "img",
                              attrs: { src: item.goods_thumb + "" },
                            }),
                            _c("div", { staticClass: "productName" }, [
                              _vm._v(" " + _vm._s(item.goods_name) + " "),
                            ]),
                            item.shop_price
                              ? _c("div", { staticClass: "price" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("moneyFormat")(item.shop_price)
                                      ) +
                                      " " +
                                      _vm._s(_vm.prepend) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                }),
                _vm.value.config.show_more === "1" &&
                rowIndex === _vm.goodsList.length - 1
                  ? _c(
                      "div",
                      {
                        class: [
                          "product",
                          "more",
                          row[0]["movie_name"] && "movie",
                        ],
                      },
                      [_vm._v(" " + _vm._s(_vm.value.config.more_name) + " ")]
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }